import { useState } from "react";
import Close from "shared/assets/images/Close.svg";
import styles from "./Accordion.module.scss";

export const Accordion = ({ title, text }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (e) => {
    setIsOpen(e.target.open);
  };

  return (
    <div className={styles.accordionWrapper}>
      <details
        className={styles.accordionWrapper__details}
        onToggle={handleToggle}
      >
        <summary className={styles.accordionWrapper__title}>
          {title}
          <img
            alt="Close"
            src={Close}
            className={
              isOpen
                ? styles.accordionWrapper__iconOpen
                : styles.accordionWrapper__iconClose
            }
          />
        </summary>
        <p className={styles.accordionWrapper__text}>{text}</p>
      </details>
    </div>
  );
};
